import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import * as Modals from "@components/modals";
import Clickoutside from "@helpers/Clickoutside";
import * as Middleware from "@middlewares/index";

const Modal = (): ReactElement => {
  const modals = useSelector((state: any) => state.Ui.Modal);

  const Components: any = Modals;

  if (modals?.length) {
    const modal = modals[modals.length - 1];
    const Component = Components[modal.modal];
    if (Component) {
      return (
        <div className="modal-background">
          <Clickoutside clickOutside={() => Middleware.Ui.Modal.closeAll()}>
            <Component {...modal.data} />
          </Clickoutside>
        </div>
      );
    }
  }
  return <></>;
};

export default Modal;
